import { render, staticRenderFns } from "./resourcesRead2.vue?vue&type=template&id=50798cbe&scoped=true&"
import script from "./resourcesRead2.vue?vue&type=script&lang=js&"
export * from "./resourcesRead2.vue?vue&type=script&lang=js&"
import style0 from "./resourcesRead2.vue?vue&type=style&index=0&id=50798cbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50798cbe",
  null
  
)

export default component.exports